// 🎯 2026 年特别开彩日期表 (YYYY-MM-DD)
const SPECIAL_DRAWS_2026 = [
  '2026-01-27', '2026-02-10', '2026-02-17', '2026-04-07', 
  '2026-07-28', '2026-09-01', '2026-10-27', '2026-12-29'
];

// 🎯 公司规则库
const CLUB_RULES = [
  { id: 1, code: 'M', name: 'Magnum', regularDays: [0, 3, 6], hasSpecial: true, defaultTime: '19:00' },
  { id: 2, code: 'P', name: 'DaMaCai', regularDays: [0, 3, 6], hasSpecial: true, defaultTime: '19:00' },
  { id: 3, code: 'T', name: 'Toto', regularDays: [0, 3, 6], hasSpecial: true, defaultTime: '19:00' },
  { id: 4, code: 'S', name: 'Singapore Pools', regularDays: [0, 3, 6], hasSpecial: false, defaultTime: '18:30' },
  { id: 5, code: 'B', name: 'Sabah', regularDays: [0, 3, 6], hasSpecial: true, defaultTime: '19:00' },
  { id: 6, code: 'K', name: 'Sandakan', regularDays: [0, 3, 6], hasSpecial: true, defaultTime: '19:00' },
  { id: 7, code: 'W', name: 'Sarawak', regularDays: [0, 3, 6], hasSpecial: true, defaultTime: '19:00' },
  { id: 8, code: 'H', name: 'GD Lotto', regularDays: [0, 1, 2, 3, 4, 5, 6], hasSpecial: false, defaultTime: '19:00' },
  { id: 9, code: 'E', name: '9Lotto', regularDays: [0, 1, 2, 3, 4, 5, 6], hasSpecial: false, defaultTime: '19:30' }
];

// 🚨 注意这里：使用了 export const 导出
export const getTodayDrawList = (dateStr?: string) => {
  const targetDate = dateStr ? new Date(dateStr) : new Date();
  
  const yyyy = targetDate.getFullYear();
  const mm = String(targetDate.getMonth() + 1).padStart(2, '0');
  const dd = String(targetDate.getDate()).padStart(2, '0');
  const formattedDate = `${yyyy}-${mm}-${dd}`;
  
  const dayOfWeek = targetDate.getDay(); 
  const isSpecialDrawDay = SPECIAL_DRAWS_2026.includes(formattedDate);

  const activeClubs = [];

  for (const club of CLUB_RULES) {
    let hasDrawToday = false;

    if (club.regularDays.includes(dayOfWeek)) {
      hasDrawToday = true;
    } 
    else if (isSpecialDrawDay && club.hasSpecial) {
      hasDrawToday = true;
    }

    if (hasDrawToday) {
      activeClubs.push({
        id: club.id,
        code: club.code,
        name: club.name,
        drawTime: club.defaultTime 
      });
    }
  }

  return activeClubs;
};
